module.exports = __webpack_public_path__ + "assets/img/duck.8103fe55.png";